import { SportsRequest } from "sb-bff-integration";
export const LibConfig = {
    regionIds: [],
    sportIds: [],
    eventState: SportsRequest.EventStateEnum.Mixed,
    allRegions: []
};
export const init = function (config) {
    LibConfig.regionIds = config.regionIds;
    LibConfig.sportIds = config.sportIds;
};
//# sourceMappingURL=init.js.map